import Backbone from "backbone";
import _ from "underscore";
import omissible from "src/shared/api/omissible";

const UPDATE_REQUEST_KEYS = [
    "name",
    "redirect_program_id",
    "ssl_generation_policy",
    "cname_target",
];

const CREATE_REQUEST_KEYS = UPDATE_REQUEST_KEYS.concat(["domain", "share_uri"]);
const OMISSIBLE_KEYS = _.without(UPDATE_REQUEST_KEYS, "redirect_program_id");

const ProgramDomainModel = Backbone.Model.extend(
    {
        urlRoot: "api:///v2/programs",

        sync(method, model, options) {
            if (method === "update" || method === "create") {
                if (method === "update") {
                    options.attrs =
                        ProgramDomainModel.parseUpdateRequest.call(this);
                } else if (method === "create") {
                    options.attrs =
                        ProgramDomainModel.parseCreateRequest.call(this);
                }
            }

            return Backbone.sync.call(this, method, model, options);
        },
    },
    {
        parseUpdateRequest() {
            const request = _.pick(this.attributes, UPDATE_REQUEST_KEYS);
            if (_.isEmpty(request.redirect_program_id)) {
                request.redirect_program_id = null;
            }
            omissible.parseAttributes(request, OMISSIBLE_KEYS, [
                "redirect_program_id",
            ]);
            if (this.get("is_extole_domain")) {
                delete request.cname_target;
            }
            if (isPrivateKeyObfuscated(this.get("ssl_private_key"))) {
                delete request.ssl_private_key;
            }
            return request;
        },

        parseCreateRequest() {
            const request = _.pick(this.attributes, CREATE_REQUEST_KEYS);
            return request;
        },
    }
);

function isPrivateKeyObfuscated(sslPrivateKey) {
    return /PRIVATE KEY VALUE/.test(sslPrivateKey);
}

export default ProgramDomainModel;
